import { createContext, useContext, useState, ReactNode } from "react"

// `calendar` is gated behind the calendarView runtime flag; TripPage falls back
// to the board when the flag is off or the trip can't be shown on a calendar.
export type LayoutMode = `horizontal` | `vertical` | `calendar`

interface LayoutModeContextType {
  layoutMode: LayoutMode
  hasUserSelected: boolean
  setLayoutMode: (mode: LayoutMode) => void
}

const LayoutModeContext = createContext<LayoutModeContextType | undefined>(
  undefined
)

function getInitialLayoutMode(): LayoutMode {
  if (typeof window !== `undefined` && window.innerWidth < 768) {
    return `vertical`
  }
  return `horizontal`
}

export function LayoutModeProvider({ children }: { children: ReactNode }) {
  const [layoutMode, setLayoutModeState] = useState<LayoutMode>(getInitialLayoutMode)
  const [hasUserSelected, setHasUserSelected] = useState(false)

  function setLayoutMode(mode: LayoutMode) {
    setLayoutModeState(mode)
    setHasUserSelected(true)
  }

  return (
    <LayoutModeContext.Provider value={{ layoutMode, hasUserSelected, setLayoutMode }}>
      {children}
    </LayoutModeContext.Provider>
  )
}

export function useLayoutMode() {
  const context = useContext(LayoutModeContext)
  if (!context) {
    throw new Error(`useLayoutMode must be used within LayoutModeProvider`)
  }
  return context
}
